import { CommonUtils } from './CommonUtils';
import { getEntityDisplayLabel, getEntityRouteParam } from './entityIdentifier';

const recordDisplayName = (entity, record, displayId) => {
  const primaryFieldName = record?.metadata?.primary_field_name ?? CommonUtils.getPrimaryField(entity)?.name;
  const primaryValue = primaryFieldName ? record?.data?.[primaryFieldName] : undefined;
  return primaryValue || record?.display_id || displayId || '';
};

const recordDisplayId = (record, displayId) => record?.display_id ?? displayId ?? '';

/**
 * Builds the ROUTE_CHANGE `meta` payload the host uses for breadcrumbs.
 * `object.path` / `record.path` are CO UI paths (no ROUTE_PREFIX).
 */
export const buildRouteChangeMeta = ({ entity, record, routeParam, displayId } = {}) => {
  const entityId = getEntityRouteParam(entity) ?? routeParam;
  const meta = {
    object: {
      name: getEntityDisplayLabel(entity) ?? '',
      id: entityId != null ? String(entityId) : '',
      path: entityId != null && entityId !== '' ? `/schemas/${entityId}/records` : '',
    },
  };

  if (record || displayId != null) {
    const recordId = recordDisplayId(record, displayId);
    meta.record = {
      name: String(recordDisplayName(entity, record, displayId)),
      id: String(recordId),
      path: entityId != null && entityId !== '' && recordId !== '' ? `/schemas/${entityId}/records/${recordId}` : '',
    };
  }

  return meta;
};
